import React from "react";

const MessageIcon = (props: any) => {
  return (
   <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M25.6673 13.4932C25.6673 19.6569 20.4432 24.6544 14.0007 24.6544C13.2431 24.6553 12.4878 24.5853 11.7436 24.4456C11.208 24.345 10.9402 24.2947 10.7533 24.3232C10.5663 24.3518 10.3014 24.4927 9.77147 24.7745C8.27248 25.5716 6.5246 25.8532 4.84361 25.5405C5.48251 24.7547 5.91885 23.8118 6.11139 22.8009C6.22806 22.1827 5.93898 21.582 5.50602 21.1423C3.53954 19.1455 2.33398 16.4546 2.33398 13.4932C2.33398 7.32953 7.55806 2.33203 14.0007 2.33203C20.4432 2.33203 25.6673 7.32953 25.6673 13.4932Z" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M13.9954 14H14.0059M18.6569 14H18.6673M9.33398 14H9.34445" stroke="#141B34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};

export default MessageIcon;
